import { render, staticRenderFns } from "./IconNotFound.vue?vue&type=template&id=013846c2&scoped=true"
import script from "./IconNotFound.vue?vue&type=script&lang=js"
export * from "./IconNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013846c2",
  null
  
)

export default component.exports